(function ($) {
	const $body = $('body');

	if ($body.hasClass('blog')) {
		$('#blog-select').on('change', function () {
			$('#blog-filter').submit();
		});
	}

	if ($body.hasClass('post-type-archive-case-studies')) {
		$('#case-studies-select').on('change', function () {
			$('#case-studies-filter').submit();
		});
	}

	if ($body.hasClass('post-type-archive-products') || $body.hasClass('tax-product-category') ) {
		$('#product-category-select').on('change', function () {
			let category = $('#product-category-select').val();

			if (category) {
				window.location.href = category;
			}
		});
	}

	if ($body.hasClass('post-type-archive-video') || $body.hasClass('tax-video-category') ) {
		$('#video-category-select').on('change', function () {
			let category = $('#video-category-select').val();

			if (category) {
				window.location.href = category;
			}
		});
	}

	if ($body.hasClass('post-type-archive-events')) {
		$('#events-select').on('change', function () {
			$('#events-filter').submit();
		});
	}

	if ($body.hasClass('post-type-archive-dealers')) {
		$('#dealers-select').on('change', function () {
			$('#dealers-filter').submit();
		});

		if (getUrlParameter('countries')) {
			$('html, body').animate(
				{
					scrollTop: $('.dealers-loop-title').offset().top - 80,
				},
				1200
			);
		}
		if (getUrlParameter('continents')) {
			$('html, body').animate(
				{
					scrollTop: $('.dealers-loop-title').offset().top - 80,
				},
				1200
			);
		}
	}
})(jQuery);

function getUrlParameter(sParam) {
	var sPageURL = window.location.search.substring(1),
		sURLVariables = sPageURL.split('?'),
		sParameterName,
		i;

	for (i = 0; i < sURLVariables.length; i++) {
		sParameterName = sURLVariables[i].split('=');

		if (sParameterName[0] === sParam) {
			return typeof sParameterName[1] === undefined
				? true
				: decodeURIComponent(sParameterName[1]);
		}
	}
	return false;
}
